(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeList', function($state, $Stores, $uibModal, uiGridConstants) {
		return {
			scope: {
				status: '@',
				data: '='
			},
			templateUrl: 'directives/storeList/table.html',
			controller: function($scope) {

                console.log('storeList => ', $scope.data);
                $scope.gridOptions = {
                    showGridFooter: true,
                    showColumnFooter: false,
                    rowHeight: 40,
                    // enableSorting: true,
                    columnDefs: [
                      { field: 'team' },
                      { field: 'name' },
                      {
                          field: 'captain',
                          enableFiltering: false,
                          enableSorting: false,
                          cellTemplate: '<div class="ui-grid-cell-contents"><a href="mailto:{{row.entity.captain.email}}">{{row.entity.captain.firstname}} {{row.entity.captain.lastname}}</a></div>',
                      },
                      {
                          field: 'products',
                          cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.products.length}}</div>',
                          width: 90,
                      },
                      {
                          field: 'packages',
                          cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.packages.length}}</div>',
                          width: 90,
                      },
                      {
                          field: 'status',
                          width: 100,
                          cellTemplate: '<div class="ui-grid-cell-contents text-capitalize">{{row.entity.status}}</div>',
                          filter: {
                            type: uiGridConstants.filter.SELECT,
                            selectOptions: [ { value: 'open', label: 'Open' }, { value: 'closed', label: 'Closed' }, { value: 'draft', label: 'Draft'} ]
                          }
                      },
                      { field: 'openDate'},
                      { field: 'closeDate'},
                      {
                          field: '$id',
                          width: 150,
                          displayName: 'Actions',
                          enableFiltering: false,
                          enableSorting: false,
                        //   filter: {
                        //       noTerm: true,
                        //       condition: function(searchTerm, cellValue) {
                        //         return cellValue.match(/a/);
                        //       }
                        //   },
                          cellTemplate: `<div class="ui-grid-cell-contents">
                            <div class="btn-group" role="group">
                              <button ng-click="grid.appScope.edit(row.entity)" class="btn btn-sm btn-default">
                                  <i class="glyphicon glyphicon-pencil"></i>
                              </button>
                              <button ng-click="grid.appScope.copy(row.entity)" class="btn btn-sm btn-default">
                                  <i class="glyphicon glyphicon-copy"></i>
                              </button>
                              <button ng-click="grid.appScope.delete(row.entity)" class="btn btn-sm btn-default">
                                  <i class="glyphicon glyphicon-trash"></i>
                              </button>
                              <a ui-sref="singleStore({ id: row.entity.$id })" target="_blank" class="btn btn-sm btn-default">
                                  <i class="glyphicon  glyphicon-upload"></i> {{ row.entity.i$d }}
                              </a>
                            </div>
                          </div>`
                      }
                    ],
                    data: $scope.data,
                    onRegisterApi: function( gridApi ) {
                      $scope.gridApi = gridApi;
                  },
                  enableColumnResizing: true,
                  enableFiltering: true,
                  enableGridMenu: true
                };

                $scope.stores = $scope.data;

				/* Filters the stores to only show specific elements. */
				$scope.filterByType = function(item) {
					if ($scope.status === 'all') return true;
					// return (item.status || '') === $scope.status;
                    return item.status === $scope.status;
				};

				/* Provided an edit option to the the modal. */
				$scope.edit = function(item) {
                    $state.go('store-detail', {id: item.$id});
				};

                $scope.copy = function (store) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Copy ${store.team} <i class="fa fa-angle-right" aria-hidden="true"></i>  ${store.name}?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="copy()">Copy</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, store) {

                            $scope.copy = function () {

                                let copy = angular.copy(store);

                                copy.name = 'Copy of ' + copy.name;
                                copy.status = 'draft';

                                $Stores.add(_.omit(copy, ['$id', '$priority']));

                                $uibModalInstance.close(store);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            store: function() {
                                return store;
                            }
                        }
                    });
		    	};

				$scope.delete = function (store) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Delete ${store.team} <i class="fa fa-angle-right" aria-hidden="true"></i>  ${store.name}?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, store) {

                            $scope.delete = function () {

                                scope.stores.$remove(store);

                                $uibModalInstance.close(store);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            store: function() {
                                return store;
                            }
                        }
                    });

		    	};

			}
		};

	});
})();
